<template>
  <v-card flat>
    <v-container>
      <v-form>
        <br>
        <h3 v-if="singleFacility.facility_type_id === 'Accomodation' && singleFacility.accomodation_type_id === 'Pelican'" class="earth-color">Special Pricing</h3>
        <v-layout row wrap v-if="singleFacility.facility_type_id === 'Accomodation' && singleFacility.accomodation_type_id === 'Pelican'">
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog"
                persistent
                v-model="modal1"
                lazy
                full-width
                width="290px"
                :return-value.sync="special_pricing.start_date"
              >
                <v-text-field
                  slot="activator"
                  label="Start Date"
                  v-model="special_pricing.start_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="special_pricing.start_date"
                  scrollable
                  :min="today"
                >
                  <v-spacer></v-spacer>
                  <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                  <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(special_pricing.start_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-dialog
                ref="dialog1"
                persistent
                v-model="modal2"
                lazy
                full-width
                width="290px"
                :return-value.sync="special_pricing.end_date"
              >
                <v-text-field
                  slot="activator"
                  label="End Date"
                  v-model="special_pricing.end_date"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="special_pricing.end_date"
                  scrollable
                  :min="special_pricing.start_date"
                >
                  <v-spacer></v-spacer>
                  <v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
                  <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(special_pricing.end_date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-autocomplete
                label="Pricing Groups"
                v-model="special_pricing.group"
                :items="curatedGroups"
                required
                item-text="facility_pricing_name"
                item-value="facility_pricing_type_public_id"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
           <v-container>
             <v-text-field
               label="From"
               type="number"
               v-model="special_pricing.from_number"
             ></v-text-field>
           </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                label="To"
                type="number"
                v-model="special_pricing.to_number"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-container>
              <v-text-field
                label="Maximum Number"
                type="number"
                v-model="special_pricing.maximum_number"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container fluid>
              <v-autocomplete
                label="Select Currency"
                v-model="special_pricing.currency_type"
                :items="allCurrencyTypes"
                :rules="[v => !!v || 'Currency is required']"
                required
                item-text="currency_name"
                item-value="currency_public_id"
                :loading="$loadingTrue"
              ></v-autocomplete>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-text-field
                label="Price within range"
                type="number"
                v-model="special_pricing.mandatory_price"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-text-field
                label="Price per extra person"
                type="number"
                v-model="special_pricing.extra_price"
              ></v-text-field>
            </v-container>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex lg3 md3 sm12 xs12>
            <v-container fluid>
              <v-btn :depressed="true" color="primary" @click.prevent="postSpecialPricing()">Add SpecialPrice Schedule</v-btn>
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>
      <hr>
      <br>
      <table cellpadding="1" cellspacing="1" class="table table-bordered">
        <thead>
        <tr>
          <td>Special Group</td>
          <td>Start Date</td>
          <td>End Date</td>
          <td>Limit</td>
          <td>Limit Price</td>
          <td>Extra Price</td>
          <td>Maximum</td>
          <td>Action</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(group, key) in specialPricing" :key="key">
          <td v-if="group.group_name.hasOwnProperty('message')">{{group.group_name.message[0]}}</td>
          <td v-else>{{group.group_name.data[0].facility_pricing_name}}</td>
          <td>{{formated_date(group.start_date)}}</td>
          <td>{{formated_date(group.end_date)}}</td>
          <td>{{group.from_number}} - {{group.to_number}}</td>
          <td>{{group.currency_type}} {{group.mandatory_price}}</td>
          <td>{{group.currency_type}} {{group.extra_price}}</td>
          <td>{{group.maximum_number}}</td>
          <td>
            <v-btn :depressed="true" color="error" @click="deleteSchedule(group.public_id)" small>Disable</v-btn>
            <!--<v-btn :depressed="true" class="btn btn-info btn-sm" @click="disableDiscount(d)">Edit</v-btn>-->
          </td>
        </tr>
        </tbody>
      </table>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'SpecialPricing',
  data () {
    return {
      today: this.$moment().format('YYYY-MM-DD'),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      special_pricing: {
        facility_id: this.$route.params.facility_id,
        session_id: '',
        child_price: '',
        adult_price: '',
        limit: [],
        upper_limit: [],
        group: '',
        start_date: '',
        end_date: '',
        maximum_number: '',
        from_number: '',
        to_number: '',
        mandatory_price: '',
        extra_price: '',
        currency_type: ''
      }
    }
  },
  methods: {
    postSpecialPricing () {
      this.$store.dispatch('post_facility_pricing', this.special_pricing)
    },
    deleteSchedule: function (publicId) {
      var data = {
        public_id: publicId,
        facility_id: this.$route.params.facility_id,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_facility_pricing', data)
    }
  },
  created () {
    this.$store.dispatch('get_facility_pricing', this.$route.params.facility_id)
    this.$store.dispatch('get_all_facility_pricing_types')
  },
  computed: {
    specialPricing () {
      var normalPricing = []
      var facilityPricing = this.$store.state.FacilityPricingStore.facility_pricing
      facilityPricing.map(function (data) {
        if (data.group !== 'None') {
          normalPricing.push(data)
        }
      })
      return normalPricing
    },
    curatedGroups () {
      var length = this.$allPricingGroups.length
      var data = []
      for (var i = 0; i < length; i++) {
        if (i > 2) {
          data.push(this.$allPricingGroups[i])
        }
      }
      return data
    }
  }
}
</script>

<style scoped>

</style>
